import { CUSTOMER_COMPUTED_BID_LIMIT } from './constants.js'

export const state = {
	[CUSTOMER_COMPUTED_BID_LIMIT]: {
		isLoading: false,
		customer_total_bids: 0,
		customer_bid_limit: 0,
		customer_computed_bid_limit: 0
	}
}
